import loading from '@i/global/loading.svg'
import NProgress from 'nprogress'
import { useInterval } from 'react-use'
import './nprogress.css'

export interface LoadingProps extends CommonProps {
  desc?: string | false
}

const Loading = (props: LoadingProps) => {
  const [dot, setDot] = useState('.')

  useInterval(() => {
    setDot(prev => (prev.length === 6 ? '.' : `${prev}.`))
  }, 500)

  useEffect(() => {
    NProgress.start()
    return () => {
      NProgress.done()
    }
  }, [])

  return (
    <div className={clsx('w-full h-full fcc flex-col', props.className)} style={props.style}>
      <img alt="loading" className="w-20" src={loading} />
      {props.desc !== false &&
        (props.desc || (
          <>
            加载中
            {dot}
          </>
        ))}
    </div>
  )
}

export default Loading
